import { useQuery } from "@tanstack/react-query";

import useApiHelper from "../hooks/useApiHelper";
import { ISingleWorkOrderResponse, IWorkOrdersResponse } from "../models/WorkOrder";

export default function useWorkOrders(workOrderId?: string, disabled: boolean = false) {
  const { get } = useApiHelper();

  const workOrders = useQuery({
    queryKey: ["workOrders"],
    queryFn: () => get<IWorkOrdersResponse>("/workorder"),
    enabled: !disabled,
    staleTime: 1000 * 60 * 2,
  });

  const workOrder = useQuery({
    queryKey: ["workOrder", workOrderId],
    queryFn: () => get<ISingleWorkOrderResponse>(`/workorder/${workOrderId}`),
    enabled: !!workOrderId && !disabled,
    staleTime: 1000 * 60 * 2,
  });

  return {
    workOrders,
    workOrder,
  };
}
